import loginReducer from "./loginSlice";
import tokenReducer from "./tokenSlice";
import inquiryReducer from "./inquirySlice";
import queriesReducer from "./queriesSlice"
import editPackage from "./packagesSlice"
import notify from "./notificationSlice"
import configReducer from "./configSlice"
import placeReducer from "./placesSlice"
import ctgReducer from "./ctgpackageSlice"
import whatsappReducer from "./whatsappSlice"
import hotelsReducer from "./hotelsSlice"
import tripManagementReducer from "./tripManagementSlice"
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Persist the selected place but not the large allPlaces list (it is refetched on every visit)
const placePersistConfig = { key: "place", storage, blacklist: ["allPlaces"] };

const rootReducer = combineReducers({
	loggedinUser: loginReducer,
	tokens: tokenReducer,
	inquiries: inquiryReducer,
	package: editPackage,
	notification: notify,
	queries: queriesReducer,
	config: configReducer,
	place: persistReducer(placePersistConfig, placeReducer),
	ctgpakage: ctgReducer,
	whatsapp: whatsappReducer,
	hotels: hotelsReducer,
	tripManagement: tripManagementReducer,
})

export default rootReducer;
